// extracted by mini-css-extract-plugin
module.exports = {"controlButtons":"control-buttons_controlButtons__L4OG4","admired":"control-buttons_admired__1dp7j"};